// extracted by mini-css-extract-plugin
export default {"Content":"EditDetachedCopiesFullView_Content__f2uUn","DetachedCopyHeader":"EditDetachedCopiesFullView_DetachedCopyHeader__CPlw4"};